// languageMap.js

const languageMap = {
  config: {
    selectedLanguage: 'he', // Default to Hebrew, you can change it as needed
  },
  navbarHome: {
    en: 'Home',
    es: 'Inicio',
    he: 'בית',
  },
  navbarServices: {
    en: 'Services',
    es: 'Servicios',
    he: 'שירותים',
  },
  navbarSignIn: {
    en: 'Sign In',
    es: 'Iniciar Sesión',
    he: 'התחבר',
  },
  navbarSignUp: {
    en: 'SIGN UP',
    es: 'REGISTRARSE',
    he: 'הרשם',
  },
  navbarLogo: {
    en: 'YHG',
    es: 'YHG',
    he: 'YHG',
  },
  heroTitle: {
    en: 'FindMe',
    es: 'Fotos de Invitados',
    he: 'FindMe',
  },
  heroSubtitle2: {
    en: 'What are you waiting for?',
    es: '¿Qué estás esperando?',
    he: 'הפתרון המושלם לתמונות האורחים האבודות',
  },
  heroSubtitle: {
    en: 'What are you waiting for?',
    es: '¿Qué estás esperando?',
    he: '?אז למה אתם מחכים',
  },
  heroGetStarted: {
    en: 'GET STARTED',
    es: 'EMPEZAR',
    he: 'התחל',
  },
  heroWatchTrailer: {
    en: 'WATCH TRAILER',
    es: 'VER AVANCE',
    he: 'צפו בדוגמא',
  },
  footerSubscribe: {
    en: 'Subscribe to our newsletter',
    es: 'Suscríbete a nuestro boletín',
    he: 'צרו איתנו קשר',
  },
  footerEmailPlaceholder: {
    en: 'Enter your email',
    es: 'Ingresa tu correo electrónico',
    he: 'הזן את כתובת האימייל שלך',
  },
  footerSubscribeButton: {
    en: 'Subscribe',
    es: 'Suscribirse',
    he: 'שלח',
  },
  footerAboutUs: {
    en: 'About Us',
    es: 'Acerca de nosotros',
    he: 'אודותינו',
  },
  footerHowItWorks: {
    en: 'How it Works',
    es: 'Cómo funciona',
    he: 'כיצד זה עובד',
  },
  footerContactUs: {
    en: 'Contact Us',
    es: 'Contáctenos',
    he: 'צור קשר',
  },
  footerContact: {
    en: 'Contact',
    es: 'Contacto',
    he: 'צור קשר',
  },
  footerSupport: {
    en: 'Support',
    es: 'Soporte',
    he: 'תמיכה',
  },
  footerSocialMedia: {
    en: 'Social Media',
    es: 'Redes sociales',
    he: 'מדיה חברתית',
  },
  footerInstagram: {
    en: 'Instagram',
    es: 'Instagram',
    he: 'אינסטגרם',
  },
  footerFacebook: {
    en: 'Facebook',
    es: 'Facebook',
    he: 'פייסבוק',
  },
  footerYoutube: {
    en: 'Youtube',
    es: 'Youtube',
    he: 'יוטיוב',
  },
  footerTwitter: {
    en: 'Twitter',
    es: 'Twitter',
    he: 'טוויטר',
  },
  footerTestimonials: {
    en: 'Testimonials',
    es: 'Testimonios',
    he: 'המלצות',
  },
  footerTermsOfService: {
    en: 'Terms of Service',
    es: 'Términos de servicio',
    he: 'תנאי השירות',
  },
  footerCopyright: {
    en: '© 2024 FindMe',
    es: '© 2024 FindMe',
    he: '© 2024 FindMe',
  },
  signUpTitle: {
    en: 'Sign Up',
    es: 'Registrarse',
    he: 'הרשמה',
  },
  signUpNameLabel: {
    en: 'Name:',
    es: 'Nombre:',
    he: 'שם מלא',
  },
  signUpEmailLabel: {
    en: 'Email:',
    es: 'Correo electrónico:',
    he: 'אימייל',
  },
  signUpPhoneLabel: {
    en: 'Phone:',
    es: 'Teléfono:',
    he: 'טלפון',
  },
  signUpPasswordLabel: {
    en: 'Password:',
    es: 'Contraseña:',
    he: 'סיסמה',
  },
  signUpButtonLabel: {
    en: 'Sign Up',
    es: 'Registrarse',
    he: 'הרשם',
  },
  signUpSuccessMessage: {
    en: 'Details saved successfully! Redirecting to sign-in page...',
    es: 'Detalles guardados exitosamente. Redireccionando a la página de inicio de sesión...',
    he: 'פרטים נשמרו בהצלחה! מעביר לדף הכניסה...',
  },
  signUpFailureMessage: {
    en: 'Failed to save details. Please try again.',
    es: 'No se pudieron guardar los detalles. Por favor, inténtalo de nuevo.',
    he: 'נכשל לשמור את הפרטים. נא לנסות שוב.',
  },
  signInTitle: {
    en: 'Sign In',
    es: 'Iniciar Sesión',
    he: 'התחברות',
  },
  signInUsernameLabel: {
    en: 'Username',
    es: 'Nombre de usuario',
    he: 'שם משתמש',
  },
  signInPasswordLabel: {
    en: 'Password',
    es: 'Contraseña',
    he: 'סיסמה',
  },
  signInButtonLabel: {
    en: 'Sign In',
    es: 'Iniciar Sesión',
    he: 'התחבר',
  },
  signInSuccessMessage: {
    en: 'Sign-in successful! Redirecting...',
    es: '¡Inicio de sesión exitoso! Redirigiendo...',
    he: 'התחברת בהצלחה! מעביר...',
  },
  signInFailureMessage: {
    en: 'Invalid credentials. Please try again.',
    es: 'Credenciales inválidas. Por favor, inténtalo de nuevo.',
    he: 'פרטי הכניסה אינם נכונים. יש לנסות שוב.',
  },
    // New translations for MyEvents component
  myEventsTitle: {
    en: 'My Events',
    es: 'Mis Eventos',
    he: 'האירועים שלי',
  },
  welcomeMessage: {
    en: 'Welcome',
    es: 'Bienvenido',
    he: 'ברוך הבא',
  },
  createNewEventButton: {
    en: 'Create New Event',
    es: 'Crear Nuevo Evento',
    he: 'צור אירוע חדש',
  },
  updateEventButton: {
    en: 'Update Event',
    es: 'Crear Nuevo Evento',
    he: 'עדכן אירוע',
  },
  getAllEventsButton: {
    en: 'Get All Events',
    es: 'Obtener Todos los Eventos',
    he: 'הצג את כל האירועים',
  },
  showUsernameButton: {
    en: 'Show Username',
    es: 'Mostrar Nombre de Usuario',
    he: 'הצג שם משתמש',
  },
  errorFetchingUserDetails: {
    en: 'Error fetching user details. Please try again.',
    es: 'Error al obtener detalles del usuario. Por favor, inténtelo de nuevo.',
    he: 'שגיאה בשליפת פרטי המשתמש. אנא נסה שוב.',
  },
  errorFetchingEvents: {
    en: 'Error fetching events. Please try again.',
    es: 'Error al obtener eventos. Por favor, inténtelo de nuevo.',
    he: 'שגיאה בשליפת האירועים. אנא נסה שוב.',
  },
  usernameAlert: {
    en: 'Username',
    es: 'Nombre de Usuario',
    he: 'שם משתמש',
  },
  eventsHeader: {
    en: 'Events:',
    es: 'Eventos:',
    he: 'אירועים:',
  },
  noEventsMessage: {
    en: 'No events available.',
    es: 'No hay eventos disponibles.',
    he: 'אין אירועים זמינים.',
  },
  eventText: {
    en: 'Event',
    es: 'Evento',
    he: 'אירוע',
  },
  photographerText: {
    en: 'Photographer',
    es: 'Fotógrafo',
    he: 'צלם',
  },  // New translations for EventDetails component
  eventDetailsTitle: {
    en: 'Event Details',
    es: 'Detalles del Evento',
    he: 'פרטי האירוע',
  },
  eventNameText: {
    en: 'Event Name',
    es: 'Nombre del Evento',
    he: 'שם האירוע',
  },
  userNameText: {
    en: 'User Name',
    es: 'Nombre de Usuario',
    he: 'שם משתמש',
  },
  goToGuestsPhotosButton: {
    en: 'Go to Guests Photos',
    es: 'Ir a Fotos de Invitados',
    he: 'רשימת אורחים',
  },
  addNewGuestButton: {
    en: 'Add New Guest',
    es: 'Agregar Nuevo Invitado',
    he: 'הוסף אורח חדש',
  },
  uploadGuestsImagesTitle: {
    en: 'Upload Guests Images',
    es: 'Subir Imágenes de Invitados',
    he: 'העלאת תמונות אורחים',
  },
  runMatchingButton: {
    en: 'Run Matching',
    es: 'Ejecutar Coincidencia',
    he: 'הפעל תהליך התאמה',
  },  
  errorRunningMatchingProcess: {
    en: 'Error running matching process:',
    es: 'Error al ejecutar el proceso de coincidencia:',
    he: 'שגיאה בהפעלת תהליך ההתאמה:',
  },
  matchingProcessInitiated: {
    en: 'Matching process initiated:',
    es: 'Proceso de coincidencia iniciado:',
    he: 'תהליך התאמה הופעל:',
  },
  noEventDetails: {
    en: 'No event details available.',
    es: 'No hay detalles disponibles del evento.',
    he: 'אין פרטים זמינים לאירוע.',
  },  // New translations for CreateNewEvent component
  createNewEventTitle: {
    en: 'Create New Event',
    es: 'Crear Nuevo Evento',
    he: 'יצירת אירוע',
  },
  updateEventTitle: {
    en: 'Update Event',
    es: 'Crear Nuevo Evento',
    he: 'עריכת אירוע',
  },
  eventNameLabel: {
    en: 'Event Name:',
    es: 'Nombre del Evento:',
    he: 'שם האירוע:',
  },
  createEventButton: {
    en: 'Create Event',
    es: 'Crear Evento',
    he: 'צור אירוע',
  },
  updateEventButton: {
    en: 'Update Event',
    es: 'Crear Evento',
    he: 'ערוך אירוע',
  },
  errorCreatingEvent: {
    en: 'Error creating event. Please try again.',
    es: 'Error al crear el evento. Por favor, inténtalo de nuevo.',
    he: 'שגיאה ביצירת האירוע. נא לנסות שוב.',
  },  // New translations for UploadImages component
  uploadImagesTitle: {
    en: 'Upload Guests Images',
    es: 'Subir Imágenes de Invitados',
    he: ' ברוכים הבאים:) העלה תמונה עדכנית שלך',
  },
  nameLabel: {
    en: 'Name:',
    es: 'Nombre:',
    he: 'שם:',
  },
  emailLabel: {
    en: 'Email:',
    es: 'Correo Electrónico:',
    he: 'דוא"ל:',
  },
  phoneLabel: {
    en: 'Phone:',
    es: 'Teléfono:',
    he: 'טלפון:',
  },
  successMessage: {
    en: 'Files uploaded successfully!',
    es: '¡Archivos subidos exitosamente!',
    he: 'הקבצים הועלו בהצלחה!',
  },  // New translations for Cards component
  cardsTitle : {
    en: "You also found yourself taking pictures endlessly and finally going out. No picture from the event? Don't do this to your guests. With Findme, your guests will be able to receive their photos already during the event",
    es: '¡Descubre estos destinos ÉPICOS!',
    he: 'כמה פעמים הצטלמתם באירוע ולא קיבלתם אף תמונה? ',
  },
  cardsTitle2 : {
    en: "You also found yourself taking pictures endlessly and finally going out. No picture from the event? Don't do this to your guests. With Findme, your guests will be able to receive their photos already during the event",
    es: '¡Descubre estos destinos ÉPICOS!',
    he: 'כמה פעמים באמת קיבלתם את התמונות שלכם?',
  },
  cardsTitle3 : {
    en: "You also found yourself taking pictures endlessly and finally going out. No picture from the event? Don't do this to your guests. With Findme, your guests will be able to receive their photos already during the event",
    es: '¡Descubre estos destinos ÉPICOS!',
    he: ' לאורחים שלכם מגיע את הטוב ביותר!!',
  },

  cardsTitle4 : {
    en: "You also found yourself taking pictures endlessly and finally going out. No picture from the event? Don't do this to your guests. With Findme, your guests will be able to receive their photos already during the event",
    es: '¡Descubre estos destinos ÉPICOS!',
    he: ' עם פיינדמי האורחים שלכם יוכלו לקבל את התמונות שלהם כבר במהלך האירוע',
  },

  cardsTitle5 : {
    en: "You also found yourself taking pictures endlessly and finally going out. No picture from the event? Don't do this to your guests. With Findme, your guests will be able to receive their photos already during the event",
    es: '¡Descubre estos destinos ÉPICOS!',
    he: "אז איך זה עובד?",
  },
  guestsUploadText: {
    en: 'Guests upload their details with a single image',
    es: 'Los invitados cargan sus detalles con una sola imagen',
    he: 'האורחים מעלים את פרטיהם עם תמונה שלהם',
  },
  photographerUploadText: {
    en: 'Photographer uploads new images to the album',
    es: 'El fotógrafo carga nuevas imágenes al álbum',
    he: ' הצלם מעלה תמונות חדשות לאלבום במהלך האירוע',
  },
  guestsReceiveText: {
    en: 'The guests receive their new images as a message',
    es: 'Los invitados reciben sus nuevas imágenes como mensaje',
    he: 'האורחים מקבלים את התמונות שלהם ישירות לטלפון הנייד',
  },
  additionalCardText1: {
    en: 'Adventure awaits! (Additional card text 1)',
    es: '¡La aventura te espera! (Texto adicional de la tarjeta 1)',
    he: 'אז תפנקו את האורחים שלכם בפיינדמי',
  },
  additionalCardText2: {
    en: 'Feel the adrenaline! (Additional card text 2)',
    es: '¡Siente la adrenalina! (Texto adicional de la tarjeta 2)',
    he: 'בהצלחה:)',
  },  servicesTitle: {
    en: 'SERVICES',
    es: 'SERVICIOS',
    he: 'שירותים',
  },
  servicesDescription: {
    en: 'Our service is able to send all your guests\' images to their phones after uploading one photo of each guest, and then all the new photos that are photographed during the event will be sent to the corresponding guests.',
    es: 'Nuestro servicio puede enviar todas las imágenes de tus invitados a sus teléfonos después de cargar una foto de cada invitado, y luego todas las nuevas fotos que se tomen durante el evento se enviarán a los invitados correspondientes.',
    he: 'השירות שלנו מסוגל לשלוח את כל תמונות האורחים שלך לטלפונים שלהם לאחר העלאת תמונה אחת של כל אורח, ואז כל התמונות החדשות שיצולמו במהלך האירוע יישלחו לאורחים המתאימים.',
  },
  fileUploadTitle: {
    en: 'File Upload',
    es: 'Subida de Archivos',
    he: 'העלאת קבצים',
  },
  uploadButtonLabel: {
    en: 'Upload',
    es: 'Subir',
    he: 'העלה',
  },
    uploadImageButtonLabel: {
    en: 'Upload image',
    es: 'Subir',
    he: 'העלה תמונה',
  },
  uploadSuccessMessage: {
    en: 'Files uploaded successfully!',
    es: 'Archivos subidos exitosamente',
    he: 'הקבצים הועלו בהצלחה!',
  },
  uploadFailureMessage: {
    en: 'Upload failed!',
    es: 'Error al subir',
    he: 'ההעלאה נכשלה!',
  },
  downloadQrCodeButton:{
    en: 'Get QR code',
    es: 'Get QR code',
    he: 'הורד QR',
  },  showLessButton: {
    en: 'Show Less',
    es: 'Mostrar menos',
    he: 'הצג פחות',
  },
  showMoreButton: {
    en: 'Show More',
    es: 'Mostrar más',
    he: 'הצג עוד',
  },
  guestsDetailsTitle: {
    en: 'Guests list',
    es: 'Mostrar más',
    he: 'רשימת אורחים',
  },
  errorFetchingGuests: {
    en: 'Error fetching guests',
    es: 'Mostrar más',
    he: 'שגיאה בטעינת רשימת האורחים',
  },
  uploadInProgressMessage: {
    en: 'Upload in progress...',
    es: 'Mostrar más',
    he: 'מעלה קבצים...',
  },
  uploadingButtonLabel: {
    en: 'Upload',
    es: 'Mostrar más',
    he: 'העלאה',
  },
  getEventLinkButton:{
    en: 'Get link',
    es: 'Mostrar más',
    he: 'לינק לאורחים',
  },
  eventName:{
    en: 'Event name',
    es: 'Mostrar más',
    he: 'שם האירוע',
  },
  FetchEventLink:{
    en: 'Get link',
    es: 'Mostrar más',
    he: 'לינק לאורחים',
  },
  copyLink:{
    en: 'Copy link',
    es: 'Mostrar más',
    he: 'העתק קישור',
  },
  galleryTitle:{
    en: 'My Gallery',
    es: 'Mostrar más',
    he: 'הגלריה שלי',
  },
  copyLink:{
    en: 'Copy Link',
    es: 'Mostrar más',
    he: 'העתק לינק',
  },
  fetchEventLink:{
    en: 'Show Link',
    es: 'Mostrar más',
    he: 'הצג לינק',
  },
  copySuccess:{
    en: 'Copied!',
    es: 'Mostrar más',
    he: 'הועתק!',
  },
  foundImages:{
    en: 'Found images',
    es: 'Mostrar más',
    he: 'תמונות שנמצאו',
  },
  loadingMessage:{
    en: 'Searching your images..',
    es: 'Mostrar más',
    he: 'מחפש את התמונות שלך..',
  },
  selecteFiles:{
    en: 'Upload',
    es: 'Mostrar más',
    he: 'העלה',
  },
  welcomePartner: {
    en: 'Wellcome, what whould you like to do?',
    es: 'Subir Imágenes de Invitados',
    he: 'שלום, מה תרצה לעשות?',
  },
  selectedFiles:{
    en: 'images selected',
    es: 'Subir Imágenes de Invitados',
    he: 'תמונות נבחרו',
  },
  acceptUpdates:{
    en: 'Accept updates',
    es: 'Subir Imágenes de Invitados',
    he: 'אישור קבלת עדכונים',
  },
  enterSignup:{
    en: 'signin/signup',
    es: 'Subir Imágenes de Invitados',
    he: 'כניסה/הרשמה',
  },
  enter:{
    en: 'Enter',
    es: 'Subir Imágenes de Invitados',
    he: 'כניסה',
  },
  contactUs:{
    en: 'Contact us',
    es: 'Subir Imágenes de Invitados',
    he: 'צור איתנו קשר ;)',
  },
  uploadFromGallery:{
    en: 'upload from gallery',
    es: 'Subir Imágenes de Invitados',
    he: 'העלה תמונה מהגלריה',
  },
  takePhoto:{
    en: 'Take photo',
    es: 'Subir Imágenes de Invitados',
    he: 'העלה תמונה',
  },
};

export default languageMap;
